import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
/**
* @class UserActivityCategory
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.userActivityCategories[0];
* const device = new UserActivityCategory(record);
* @property {NUMBER} _id - The id of the userActivityCategory
* @property {STRING} _description - The description of the userActivityCategory
*/

export default class UserActivityCategory extends BCMSRecord {
    _id
    _description
    
    constructor (record){     
      super( record  ) 
    }
  }
UserActivityCategory.define({
    "recordType":"userActivityCategories",
    "recordIDProp":"id",
    "className" : "UserActivityCategory",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the userActivityCategory
         * @property set {NUMBER} - sets the id of the userActivityCategory
         * @memberof UserActivityCategory
         */
        BCMSRecordProperty.mapToNumber("id", "_id", "id"),

        /** 
         * @name description
         * @instance
         * @property get {NUMBER} - gets the description of the userActivityCategory
         * @property set {NUMBER} - sets the description of the userActivityCategory
         * @memberof UserActivityCategory
         */
        BCMSRecordProperty.mapToString("description", "_description", "description"),
      ]
})




